module.exports = __webpack_public_path__ + "static/media/wn_4fullbodyIMG_3509.c9593345.jpg";